var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMenuList = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24.001,
    viewBox: "0 0 24 24.001",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13115.518 15424.493)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.481 -1.492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M646.939,462.278a2.94,2.94,0,1,0,2.992,2.94A2.967,2.967,0,0,0,646.939,462.278Zm0,4.694h0a1.755,1.755,0,1,1,1.786-1.756A1.77,1.77,0,0,1,646.939,466.972Z",
    transform: "translate(12473.053 -15885.278)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.162,
    height: 1.707,
    rx: 0.785,
    transform: "translate(13125.838 -15420.871)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.939,470.608a2.94,2.94,0,1,0,2.992,2.94A2.967,2.967,0,0,0,646.939,470.608Zm0,4.694a1.755,1.755,0,1,1,1.786-1.755A1.77,1.77,0,0,1,646.939,475.3Z",
    transform: "translate(12473.053 -15884.549)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.162,
    height: 1.707,
    rx: 0.785,
    transform: "translate(13125.838 -15411.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.939,478.938a2.94,2.94,0,1,0,2.992,2.94v0A2.966,2.966,0,0,0,646.939,478.938Zm0,4.692v0a1.755,1.755,0,1,1,1.786-1.755A1.77,1.77,0,0,1,646.939,483.632Z",
    transform: "translate(12473.053 -15883.817)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.162,
    height: 1.707,
    rx: 0.785,
    transform: "translate(13125.838 -15402.835)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuList, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/menu-list.8738442c.svg";
export { ForwardRef as ReactComponent };